<!--
/*******************************************************************************
*@ 컴포넌트명   : interestRatesStep1ogauc.vue
*@ 컴포넌트설명 :[인도] 예금 상품 > 금리 안내(기업)
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 2021.10.13   주형진  
********************************************************************************/
-->
<template>
  <div>
    <div class="cont-tit">
      <h6>{{ /*정기예금*/ $t("MDEP-01-02-01-30") }}</h6>
      <div class="tbl-top-etc">{{ /*(연이율, 세전, 단위 : %)*/ $t("MDEP-01-02-01-08") }}</div>
    </div>
    <table class="table -type02">
      <colgroup>
        <col width="30%" />
        <col width="40%" />
        <col />
      </colgroup>
      <tbody>
        <template v-if="lnag == $config.LANG_KOR">
          <tr>
            <th scope="row" rowspan="3">{{ /*기간*/ $t("MDEP-01-02-02-06") }}</th>
            <th scope="row">영업점 문의</th>
            <td></td>
          </tr>
        </template>
        <template v-else>
          <tr>
            <th scope="row" rowspan="3">{{ /*기간*/ $t("MDEP-01-02-02-06") }}</th>
            <th scope="row">Contact us</th>
            <td></td>
          </tr>
        </template>
      </tbody>
    </table>
    <div class="cont-tit">
      <h6>{{ /*적금*/ $t("MDEP-02-01-01-04") }}</h6>
      <div class="tbl-top-etc">{{ /*(연이율, 세전, 단위 : %)*/ $t("MDEP-01-02-01-08") }}</div>
    </div>
    <table class="table -type02">
      <colgroup>
        <col width="30%" />
        <col width="40%" />
        <col />
      </colgroup>
      <tbody>
        <template v-if="lnag == $config.LANG_KOR">
          <tr>
            <th scope="row" rowspan="3">{{ /*기간*/ $t("MDEP-01-02-02-06") }}</th>
            <th scope="row">영업점 문의</th>
            <td></td>
          </tr>
        </template>
        <template v-else>
          <tr>
            <th scope="row" rowspan="3">{{ /*기간*/ $t("MDEP-01-02-02-06") }}</th>
            <th scope="row">Contact us</th>
            <td></td>
          </tr>
        </template>
      </tbody>
    </table>
    <div class="cont-tit">
      <h6>{{ /*요구불예금*/ $t("MDEP-01-02-01-32") }}</h6>
      <div class="tbl-top-etc">{{ /*(연이율, 세전, 단위 : %)*/ $t("MDEP-01-02-01-08") }}</div>
    </div>
    <table class="table -type02">
      <colgroup>
        <col width="50%" />
        <col width="50%" />
        <col />
      </colgroup>
      <tbody>
        <tr>
          <th scope="row">{{ /*기간*/ $t("MDEP-01-02-02-06") }}</th>
          <td>0.00%</td>
        </tr>
      </tbody>
    </table>
    <div class="info info-type4">
      <p>※ {{ /*금리 적용일*/ $t("MDEP-01-02-03-19") }} : 09.06.2020</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentTab: 1,
    };
  },
};
</script>
